<template>
  <div class="topBox">
    <div class="left">
      <img src="../../assets/img/datas/u2021.png" />
    </div>
    <div class="middle">
      <span class="tit">{{ title }}</span>
    </div>
    <!-- :class="projectType ? 'typeApp' : ''" -->
    <div class="download-app" v-if="downStatus" :style="downloadStyle" @click="downloadApp">应用下载</div>
    <div class="right">
      <div class="date">{{ nowTime }}</div>
      <div class="hour">{{ hour }}</div>
      <div class="week">{{ week }}</div>
      <div class="fullBtn" @click="fullscreenchange" v-if="isFull">{{ isFullScreen ? '退出' : '全屏' }}</div>
    </div>
    <!-- 闪光 -->
    <div class="flashModule"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: '见犊补母数据可视化'
    },
    downloadStyle: {},
    downStatus: false
  },
  data() {
    return {
      hour: '',
      week: '',
      nowTime: '',
      timer: null,
      isFullScreen: false,
      isFull: false
    };
  },
  created() {
    const that = this;
    this.isFull = false;
    this.$nextTick(() => {
      setTimeout(() => {
        that.isFull = true;
      }, 3000);
    }, 1000);
    this.nowTimes();
  },
  methods: {
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
      let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? '0' + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ['日', '一', '二', '三', '四', '五', '六'];
      let getWeek = '星期' + weeks[week];
      let nowTime = year + '-' + month + '-' + date + '';
      this.hour = hh + ':' + mm + ':' + ss;
      this.week = getWeek;
      return nowTime;
    },
    nowTimes() {
      this.nowTime = this.timeFormate(new Date());
      this.timer = setInterval(() => {
        this.nowTime = this.timeFormate(new Date());
      }, 1000);
    },
    fullscreenTirgger() {
      this.isFullScreen = !this.isFullScreen;
    },
    fullscreenchange() {
      this.isFullScreen = !this.isFullScreen;
      this.$emit('screen', this.isFullScreen);
      if (this.isFullScreen) {
        this.$nextTick(() => {
          setTimeout(() => {
            localStorage.setItem('WhetherToTriggerFullScreen', 1);
          }, 500);
        }, 500);
      } else {
        localStorage.setItem('WhetherToTriggerFullScreen', '');
      }
    },
    // 下载
    downloadApp() {
      this.$emit('downLoadCallBack');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/allocation.scss';
.topBox {
  background-image: url('../../../static/large/heade-bg.png');
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  color: $fontSizefff;
  position: relative;
  .left,
  .middle,
  .right {
    width: 29%;
  }

  .left {
    img {
      height: 1.5vw;
      margin-left: 1.3vw;
      margin-top: 0.325vw;
    }
  }

  .middle {
    text-align: center;
    line-height: 4.68vw;

    .tit {
      font-size: 1.6vw;
      text-align: center;
      // font-family: Medium;
      font-family: 'titleFont';
      letter-spacing: 0.1vw;
    }
  }

  .right {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
    position: relative;

    .date {
      font-size: 0.7vw;
      font-family: Regular;
      position: absolute;
      right: 1.1vw;
      top: 4vw;
    }

    .hour {
      font-size: 1.789vw;
      font-family: Regular;
      position: absolute;
      right: 5.263vw;
      top: 2.894vw;
      font-weight: 400;
    }
    .week {
      font-size: 0.75vw;
      font-family: Regular;
      position: absolute;
      right: 2.368vw;
      top: 3.157vw;
    }
    .fullBtn {
      width: 3.789vw;
      height: 1.473vw;
      border: none;
      background: url('../../../static/large/full.png');
      background-size: 100% 100%;
      line-height: 1.473vw;
      font-size: 0.75vw;
      margin-right: 1.1vw;
      position: absolute;
      right: 0;
      top: 0.315vw;
      text-align: center;
      cursor: pointer;
      font-family: Medium;
    }

    // .fullBtn {
    //   width: 92px;
    //   height: 40px;
    //   background: #0f2733;
    //   border: 1px solid #00f9ee;
    //   font-size: 16px;
    //   line-height: 40px;
    //   color: #d9d9d9;
    //   font-weight: normal;
    //   text-align: center;
    //   border-radius: 10px;
    //   cursor: pointer;
    // }
  }
}

.download-app {
  position: absolute;
  right: 0;
  top: 3.421vw;
  width: 4.421vw;
  height: 1.5vw;
  line-height: 1.5vw;
  background: url('../SmartLivestock-zzry/map/img/type-text.png') no-repeat;
  background-size: 100% 100%;
  text-align: center;
  cursor: pointer;
  z-index: 200;
  font-size: 0.9vw;
}

.flashModule {
  width: 1.5vw;
  height: 0.157vw;
  background: radial-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  background: -webkit-radial-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  position: absolute;
  left: 0; // 0 10[0.5]
  bottom: 0.105vw;
  animation: flashKeyFrames 2s linear infinite;
}

@keyframes flashKeyFrames {
  0% {
    left: 0;
    opacity: 0;
  }

  35% {
    opacity: 0;
  }

  36% {
    left: 35.8%;
    opacity: 1;
    transform: scale(0.2);
  }

  40% {
    left: 40%;
    transform: scale(1);
    opacity: 1;
  }

  58% {
    left: 58%;
    transform: scale(1);
    opacity: 1;
  }

  62% {
    left: 62%;
    transform: scale(0.2);
    opacity: 1;
  }

  63% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/visualHead.vue